import { sectors } from "@/api";

import { farmUseCase } from "@/api/modules/farm/useCases";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";
import { saveVolumeUseCase } from "@/api/modules/volume/useCases/saveDailyVolumes";

import { saveEt0UseCase } from "@/api/modules/station/saveEt0";
import { saveRainfallUseCase } from "@/api/modules/station/saveRainfall";

import calcManagement from "@/mixins/calcManagement";
// import { deleteVolumeBySector } from "@/api/modules/volume/useCases/deleteRecordsVolumesBySector";

import moment from "moment";

import { reports } from "@/api";

import { concatData, fixFloatValue } from "@/pages/components/helpers";
import { organizeToTable } from "@/pages/components/monit/report";
import { management, monit, monitChart } from "@/api";

import { organizeLog } from "@/pages/components/monit/charts";

//testes
import { soilUseCase } from "@/api/modules/soil/useCases";
import { managementFarmDapUseCase } from "@/api/modules/farms_dap/useCases/getManagementFarmDAP";

import { getStationOptionsUseCase } from "@/api/modules/station/getStationOptions";

import { getEt0ByIntervalUseCase } from "@/api/modules/station/getEt0ByInterval";
import { getRainfallByIntervalUseCase } from "@/api/modules/station/getRainfallByInterval";
import { getEt0SinceFirstLogUseCase } from "@/api/modules/station/getEt0SinceFirstLog";
import { getRainfallSinceFirstLogUseCase } from "@/api/modules/station/getRainfallSinceFirstLog";

import { checkIfFarmDapExists } from "@/api/modules/farms_dap/useCases/checkIfExistsFarmDap";

import { saveManagementUseCase } from "@/api/modules/management/useCase/save";
import { getManagementRainfallInputByIdlUseCase } from "@/api/modules/management/useCase/getRainfallInputsByIdSector";

import { deleteManagementBySectorAndInterval } from "@/api/modules/management/useCase/deleteBySectorAndInterval";
// import { getLastRecordFromManagementByIdSector } from "@/api/modules/management/useCase/getManagementBySectorAndInterval";
// import { getManagementByIdSectorAndIntervalUseCase } from "@/api/modules/management/useCase/getLastRecordFromManagement";
import { getLastRecordFromManagementByIdSector } from "../api/modules/management/useCase/getLastRecordFromManagement";
import { getManagementByIdSectorAndIntervalUseCase } from "../api/modules/management/useCase/getManagementBySectorAndInterval";

import { updateOffsetSectorByIdSector } from "@/api/modules/log_sector/useCase/updateByIdSector";
import { showLogSectorByIdAndTimeUseCase } from "@/api/modules/log_sector/useCase/showByTimeAndIdSector";
import { createLogSectorUseCase } from "@/api/modules/log_sector/useCase/create";
import { deleteLogSectorByIdUseCase } from "@/api/modules/log_sector/useCase/delete";

import { deleteManagementByIdSector } from "@/api/modules/management/useCase/deleteByIdSector";
import { deleteVolumeBySector } from "@/api/modules/volume/useCases/deleteRecordsVolumesBySector";
import { deleteVolumeByInterval } from "@/api/modules/volume/useCases/deleteVolumeByInterval";

import { getVolumeByIdSectorAndTimeUseCase } from "@/api/modules/volume/useCases/getVolumeByIdSectorAndTime";
import { getFirstVolumeLogFromValveUseCase } from "@/api/modules/volume/useCases/getFirstVolumeLogFromValve";
import { getVolumeSinceFirstLogUseCase } from "@/api/modules/volume/useCases/getVolumeSinceFirstLog";
import { cookies } from "../pages/components/cookies";
import { getVolumesInInterval } from "../api/modules/volume/useCases/getVolumesInInterval";

export default {
  mixins: [calcManagement],
  methods: {
    async updateFarmEditorRefact({ name, fkEditor, idItem, formType }) {
      // console.log('creating farm', {name, fkEditor, idItem, formType})
      if (formType === "add") {
        const farmID = await farmUseCase().getFarmIdByName.execute(name);
        await farmUseCase().updateFkEditor.execute(farmID, fkEditor);
      } else {
        await farmUseCase().updateFkEditor.execute(idItem, fkEditor);
      }
    },
    async updateSoilEditorRefact({ name, fkEditor, idSoil, formType }) {
      if (formType === "add") {
        const soilId = await soilUseCase().getSoilIdByName.execute(name);
        // console.log({soilId})
        await soilUseCase().updateFkEditor.execute(soilId, fkEditor);
      } else {
        await soilUseCase().updateFkEditor.execute(idSoil, fkEditor);
      }
    },
    async generateManagementRefact({ idSoil }) {
      try {
        if (!idSoil) {
          return;
        }

        this.loadingRecalc = true;
        this.currentLoadingMessage =
          "Procurando setores atrelados a este solo...";
        const managementSectors = await this.getManagementSectors({
          ID_SOIL: idSoil,
        });

        if (managementSectors && managementSectors.length) {
          this.currentLoadingMessage =
            "Recalculando setores dependentes deste solo...";
          await this.recalcSectorsManagement(managementSectors);
        }

        this.loadingRecalc = false;
        alert("Sucesso ao realizar calculo de manejo", "s");
      } catch (e) {
        this.loadingRecalc = false;
        alert("Erro ao realizar calculo de manejo", "e");
        console.log(e);
      }
    },
    async calcVolumes(idSector) {
      const complementLog = `${
        idSector
          ? `do setor ${idSector}`
          : "de todos os setores de manejo não colhidos"
      }.`;
      // console.log(
      //   `[calcVolumes] - Iniciando calculo de volumes ${complementLog}`
      // );
      const responseVolumesInsert = await management.calcVolumes(idSector);

      // console.log(
      //   `[calcVolumes] - Finalizado o calculo de volumes ${complementLog}`
      // );

      return responseVolumesInsert;
    },
    async getManagementSectors({ ID_FARM, ID_SOIL }) {
      let whereClause = `WHERE (
        ${ID_FARM ? "ID_FARM =" + ID_FARM : ""}
        ${ID_FARM && ID_SOIL ? "AND" : ""}
        ${ID_SOIL ? "ID_SOIL =" + ID_SOIL : ""}
      )`;

      const raw = `
        SELECT
          NEWSIR_SECTOR.*,
          CROP_SECTOR.*,
          SECTOR_VALVE.ID_VALVE,
          CAD_VALVE.NAME AS VALVE_NAME
        FROM CROP.CAD_SECTOR CROP_SECTOR
        JOIN NEWSIR.CAD_SECTOR NEWSIR_SECTOR
        ON NEWSIR_SECTOR.ID = CROP_SECTOR.ID_SECTOR
        LEFT JOIN NEWSIR.SECTOR_HAS_VALVE SECTOR_VALVE
        ON SECTOR_VALVE.ID_SECTOR = CROP_SECTOR.ID_SECTOR
        LEFT JOIN NEWSIR.CAD_VALVE CAD_VALVE
        ON CAD_VALVE.ID = SECTOR_VALVE.ID_VALVE
        ${ID_SOIL || ID_FARM ? whereClause : ""};
      `;

      return await management
        .sql({ data: { sql: raw } })
        .then((resp) => resp[0]);
    },
    async recalcSectorsManagement(sectors) {
      try {
        await Promise.all(
          sectors.map(async (sector) => {
            const {
              OFFSET_DAP,
              DATE_CROP,
              SPACING_BETWEEN_LINES,
              SPACING_BETWEEN_PLANTS,
              PRESSURIZE_TIME,
              TIME_ADVANCE,
              AVG_TIME_PULSE,
              APPLICATION_RATE,
              SYSTEM_EFFICIENCY,
              ID_SECTOR,
              ID_SOIL,
              ID_FARM,
              SECTOR_NAME,
              IS_MANAGEMENT,
              INITIAL_STORAGE,
              VOLUME_DATE,
              ...SECTOR
            } = sector;

            SECTOR.valves = [
              {
                ID: SECTOR.ID_VALVE,
                NAME: SECTOR.VALVE_NAME,
              },
            ];

            const MANAGEMENT = {
              OFFSET_DAP,
              DATE_CROP,
              SPACING_BETWEEN_LINES,
              SPACING_BETWEEN_PLANTS,
              PRESSURIZE_TIME,
              TIME_ADVANCE,
              AVG_TIME_PULSE,
              APPLICATION_RATE,
              SYSTEM_EFFICIENCY,
              ID_SECTOR,
              ID_SOIL,
              ID_FARM,
              SECTOR_NAME,
              IS_MANAGEMENT,
              INITIAL_STORAGE,
              VOLUME_DATE,
            };

            const SECTOR_PROPS = { SECTOR, MANAGEMENT };

            const sectorId =
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;
            const rainfall_inputs =
              await getManagementRainfallInputByIdlUseCase().execute(sectorId);

            const managementData = await this.calcManagementData(
              SECTOR_PROPS,
              rainfall_inputs
            );

            if (managementData.length) {
              await this.registerManagement(sectorId, managementData);
            }
          })
        );
      } catch (e) {
        console.error(e);
      }
    },
    shuffleVolumeLogs(
      volumes,
      start = null,
      end = null,
      recalcUntilCrop = false
    ) {
      let only_time = volumes.map((vol) => vol[0]).filter((el) => !!el);

      const START = start ? start : only_time[0]; //Primeiro registro de volume
      // Data de ontem (último registro)
      const END = recalcUntilCrop
        ? moment(end).hour(23).minute(59).format("YYYY-MM-DD")
        : moment()
            // .subtract(1, "day")
            .hour(23)
            .minute(59)
            .format("YYYY-MM-DD");

      let index = 0;

      let current_date = START;
      //Preencher com dias que faltam
      for (
        current_date;
        current_date < END;
        current_date = moment(current_date).add(1, "day").format("YYYY-MM-DD")
      ) {
        if (only_time.some((time) => time === current_date)) {
          index += 1;
          continue;
        }
        volumes.splice(index, 0, [current_date, "0.00"]);
        index += 1;
      }

      volumes.sort((a, b) => {
        if (moment(a[0]).diff(moment(b[0])) > 0) {
          return 1;
        }
        return -1;
      });
      return volumes;
    },
    async getEt0AndRainfallInTimeInterval(start, end) {
      const et0 = await getEt0ByIntervalUseCase.execute(start, end);
      const rainfall = await getRainfallByIntervalUseCase.execute(start, end);

      return {
        et0,
        rainfall,
      };
    },
    async saveStationDatas(datas) {
      if (!datas) {
        return;
      }

      const { et0, rainfall } = datas;

      // console.log(":) Salvando dados de ET0 e Rainfall >>> ", {
      //   et0,
      //   rainfall
      // });
      //Salva no CROP
      if (et0) {
        await saveEt0UseCase.execute(et0);
      }
      if (rainfall) {
        await saveRainfallUseCase.execute(rainfall);
      }
    },
    sectorCroped(dateCrop) {
      const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
      return moment(tomorrow).isAfter(dateCrop);
    },
    async organizeVolumeLogs({
      FK_SECTOR,
      PAYLOAD,
      HAS_MANAGEMENT_DATE,
      LOGS,
    }) {
      let volumeData = {};
      let { start, end, elements } = PAYLOAD;
      // Se conseguir buscar alguma informação da válvula de volume
      if (LOGS && LOGS[0] && LOGS[0].length) {
        let logs = [
          {
            ID: elements.ID,
            NAME: elements.NAME,
            VALUE: LOGS[0],
          },
        ];
        concatData(logs, PAYLOAD, (valve_data) => {
          organizeToTable(valve_data, PAYLOAD, (concatenatedData) => {
            //Se estatus for 'true' então é sinal que conseguiu organizar os dados
            // de volume por dia
            if (concatenatedData.status) {
              // Não pega o título só os dados
              // Ex: Desconsidera o ["DATA","YYYY-MM-DD"]
              const daily_volumes = concatenatedData.table[0].slice(1);
              //Tiver mais de um registro de volume
              // Então vai organizar os dados sem deixar passar um dia
              if (daily_volumes.length > 1) {
                let VOLUMES;
                //Se passar a data inicial de manejo, terá que considerar ela
                if (HAS_MANAGEMENT_DATE) {
                  VOLUMES = this.shuffleVolumeLogs(
                    daily_volumes,
                    start,
                    end,
                    this.recalcUntilDateCrop
                  );
                } else {
                  VOLUMES = this.shuffleVolumeLogs(
                    daily_volumes,
                    null,
                    end,
                    this.recalcUntilDateCrop
                  );
                }
                volumeData = {
                  FK_SECTOR,
                  FK_VALVE: elements.ID,
                  VOLUMES,
                };
              } else {
                volumeData = {
                  FK_SECTOR,
                  FK_VALVE: elements.ID,
                  VOLUMES: daily_volumes,
                };
              }
            } else {
              // console.log(
              //   ">>> Não foi possível organizar os dados para cálculo de volume"
              // );
              //Data de ontem
              const END = moment(end).subtract(1, "day").format("YYYY-MM-DD");

              volumeData = {
                FK_SECTOR,
                FK_VALVE: elements.ID,
                VOLUMES: [[END, "0.00"]],
              };
            }
          });
        });

        return volumeData;
      }
      //Se não conseguir pegar nenhum registro de volume de válvula, ex:
      // válvula não existe no LOG_ACTUATOR mas existe no NEWSIR
      else {
        // console.log(
        //   `>>> Não foi possível organizar os dados para cálculo de volume da válvula >>> ${elements.NAME}`
        // );

        /*
          SE "HAS_MANAGEMENT_DATE" FOR true ENTÃO IRÁ TER QUE REALIZAR A SEGUINTE CONDIÇÃO:
            - ORGANIZAR DADOS DE VOLUME COMEÇANDO DE start (DATA INICIAL DE MANEJO) ATÉ a data de ontem
            COLOCANDO TUDO COMO SENDO "0.00" JÁ QUE NÃO VAI TER DADOS NO LOG_ACTUATOR
        */
        if (HAS_MANAGEMENT_DATE) {
          const VOLUMES = this.shuffleVolumeLogs(
            [],
            start,
            end,
            this.recalcUntilDateCrop
          );
          return {
            FK_SECTOR,
            FK_VALVE: elements.ID,
            VOLUMES: VOLUMES,
          };
        }
        //Data de ontem
        const END = moment(end).subtract(1, "day").format("YYYY-MM-DD");

        //Irá pelo menos guardar o valor de ontem como 0.00 para ser salvo no banco
        return {
          FK_SECTOR,
          FK_VALVE: elements.ID,
          VOLUMES: [[END, "0.00"]],
        };
      }
    },
    shouldHaveHistory(dateTime) {
      if (dateTime) {
        return !moment(dateTime).isBefore(moment().format("YYYY-MM-DD"));
      }
    },
    async calcPrepareStationData({
      FK_VALVE,
      FK_SECTOR,
      VOLUME_DATE,
      PAYLOAD,
      HAS_CHANGED_VALVES,
    }) {
      // TODO
      // REMOVE CALC OF VOLUME USELESS AND SAVE OF VOLUME

      // console.log(
      //   `>>> Iniciando cálculo de volume, et0 e precipitação a partir da data inicial de manejo : ${VOLUME_DATE} `
      // );

      let volumes = {};
      let rainfallData;
      // Só irá ter valores quando for detectado que possui dias faltando persistir ou não existe nada no banco de ET0.
      let et0Data;

      try {
        const valveLogs = await reports.search({
          ...PAYLOAD,
        });

        volumes = await this.organizeVolumeLogs({
          FK_SECTOR,
          PAYLOAD,
          HAS_MANAGEMENT_DATE: !!VOLUME_DATE,
          LOGS: valveLogs,
        });
        // Caso tenha algum valor de Volume
        if (Reflect.has(volumes, "VOLUMES") && volumes.VOLUMES.length) {
          let filteredEt0AndRainfallLogs;
          let firstOccurrenceOfVol = volumes.VOLUMES.findIndex((row) => {
            let [, value] = row;
            return Number(value) > 0;
          });

          const hasManagementInitialDate = !!VOLUME_DATE;

          if (firstOccurrenceOfVol >= 0 && !hasManagementInitialDate) {
            volumes.VOLUMES = volumes.VOLUMES.slice(firstOccurrenceOfVol);
          }
          //Não estiver passando a data inicial de manejo então é só pegar a data de ontem
          //Caso contrário irá pegar todos os valoes mesmo sendo todos 0.00, pois quem manda é a data inicial de manejo
          else if (!hasManagementInitialDate) {
            volumes.VOLUMES = [volumes.VOLUMES[volumes.VOLUMES.length - 1]];
          }

          // TODO : IMPROVE LOGIC botei esse || VOLUME_DATE como paliativo
          const first_register_from_volume =
            (volumes.VOLUMES[0] && volumes.VOLUMES[0][0]) || VOLUME_DATE;
          const last_register_from_volume =
            (volumes.VOLUMES[volumes.VOLUMES.length - 1] &&
              volumes.VOLUMES[volumes.VOLUMES.length - 1][0]) ||
            VOLUME_DATE;

          // - Buscar dados de volume da válvula caso não estiver trocando de válvula

          // console.log(
          //   `>>> Foi calculado volume de ${first_register_from_volume} até ${last_register_from_volume}`
          // );

          const volumesAlreadyExistsInDatabase = await getVolumesInInterval({
            FK_VALVE,
            FK_SECTOR,
            START: first_register_from_volume,
            END: last_register_from_volume,
          });

          // OBS: Solução mais lenta
          let onlyTimesOfvolumesFromDatabase;
          let diffVolumes;
          //Se já existe dados salvos de volume no banco
          if (volumesAlreadyExistsInDatabase.length) {
            // const calculatedTimes = volumes.VOLUMES.map((vol) => vol[0])
            onlyTimesOfvolumesFromDatabase = volumesAlreadyExistsInDatabase.map(
              (vol) => vol.TIME
            );

            let diffTimes = volumes.VOLUMES.filter((vol) => {
              if (
                !onlyTimesOfvolumesFromDatabase.some((et0) => et0 == vol[0])
              ) {
                return true;
              }
            });

            //Se houver algum volume novo calculado que não está no banco
            diffVolumes = {
              FK_SECTOR,
              FK_VALVE,
              VOLUMES: diffTimes,
            };

            const valveFirstVolumeLog =
              await getFirstVolumeLogFromValveUseCase.execute(
                FK_SECTOR,
                FK_VALVE
              );
            //Se a primeira data que está no banco de volume for menor do que a primeira
            //data de volume recém calculado, então significa que irá ter que apagar os dados
            // no banco anteriores aos que está sendo calculado.
            // if(moment(volumesAlreadyExistsInDatabase[0].TIME).isBefore(moment(volumes.VOLUMES[0][0])))
            const fist_register_from_volume_in_database =
              valveFirstVolumeLog.TIME;

            const hasOldRegistersToDelete = moment(
              fist_register_from_volume_in_database
            ).isBefore(first_register_from_volume, "days");
            //Tiver datas antigas então apaga elas
            if (hasOldRegistersToDelete) {
              const endDate = moment(first_register_from_volume)
                .subtract(1, "days")
                .format("YYYY-MM-DD");
              // console.log(
              //   `>>> Apagando dados de volume de ${fist_register_from_volume_in_database} até ${endDate}`
              // );

              await deleteVolumeByInterval().execute(
                FK_SECTOR,
                fist_register_from_volume_in_database,
                endDate
              );
            }
          }
          // console.log(
          //   `>>> Há dados de volume de ${first_register_from_volume} até ${last_register_from_volume}`
          // );
          //OBS: Não apagar dados de volume quando não trocar a válvula, terá que salvar somente dados que estão faltando no banco
          if (HAS_CHANGED_VALVES) {
            await deleteVolumeByInterval().execute(
              FK_SECTOR,
              first_register_from_volume,
              last_register_from_volume
            );
          }

          // Buscar no banco se tem dados de ET0 e Rainfall nesse intervalo de tempo
          filteredEt0AndRainfallLogs =
            await this.getEt0AndRainfallInTimeInterval(
              first_register_from_volume,
              last_register_from_volume
            );

          if (
            !filteredEt0AndRainfallLogs ||
            (!filteredEt0AndRainfallLogs.et0.length &&
              !filteredEt0AndRainfallLogs.rainfall.length)
          ) {
            // console.log(
            //   `>>> Não há registro de ET0 e Rainfall de ${first_register_from_volume} até ${last_register_from_volume}.`
            // );
            // console.log(
            //   `>>> Calculando ET0 e Rainfall de ${first_register_from_volume} até ${last_register_from_volume}.`
            // );

            const stationData = await this.calcEt0AndRainfall(
              first_register_from_volume,
              moment(last_register_from_volume)
                .add(1, "day")
                .format("YYYY-MM-DD")
            );

            if (stationData) {
              const { et0, rainfall } = stationData;
              et0Data = et0;
              rainfallData = rainfall;
            }
          }
          // Caso tenha algum registro nesse intervalo de tempo
          else {
            const onlyVolumesTimes = volumes.VOLUMES.map((vol) => vol[0]);
            const onlyEt0Times = filteredEt0AndRainfallLogs.et0.map(
              (et0) => et0.TIME
            );

            const onlyRainfallTimes = filteredEt0AndRainfallLogs.rainfall.map(
              (et0) => et0.TIME
            );

            let diffTimes = onlyVolumesTimes.filter((vol) => {
              if (!onlyEt0Times.some((et0) => et0 == vol)) {
                return true;
              }
            });
            //Pega só os dias que faltam
            if (diffTimes.length) {
              // console.log(
              //   `>>> Calculando ET0 e Rainfall de ${diffTimes[0]} até ${
              //     diffTimes[diffTimes.length - 1]
              //   }.`
              // );

              let { et0, rainfall } = await this.calcEt0AndRainfall(
                diffTimes[0],
                moment(diffTimes[diffTimes.length - 1])
                  .add(1, "day")
                  .format("YYYY-MM-DD")
              );

              //Retira os dados de et0 recém calculados que já existem no banco
              et0.DATA = et0.DATA.filter((et0) => {
                if (!onlyEt0Times.some((et0Time) => et0Time === et0[0])) {
                  return true;
                }
              });

              rainfall.DATA = rainfall.DATA.filter((rainfall) => {
                if (
                  !onlyRainfallTimes.some((et0Time) => et0Time === rainfall[0])
                ) {
                  return true;
                }
              });

              et0Data = et0;
              rainfallData = rainfall;
            }
            //Dias forem todos iguais, não precisa calcular ET0 e Rainfall, apenas salva o volume
            else {
              // console.log(
              //   `[calcStationData] - Não irá ser calculado  ET0 e Rainfall pois já existe dados de ${first_register_from_volume} até ${last_register_from_volume}`
              // );
            }
          }
          // Filtrar et0s que chegaram aqui como 0;
          // et0Data.filter(et0 => Number(et0)
          if (et0Data)
            // só quando houver dias faltando serem salvos no banco de ET0.
            et0Data.DATA = et0Data.DATA.filter((et0) => Number(et0[1]));

          // Não tiver encontrado nenhuma ocorrência de volume maior do que 0 no array
          // de volume calculados de 1 mês atrás, então salva pelo menos o último (ontem)
          //Salvamento dos dados no banco
          return {
            et0: et0Data,
            volume: volumesAlreadyExistsInDatabase.length
              ? diffVolumes
              : volumes,
            rainfall: rainfallData,
          };
        } else {
          // console.error(
          //   "[calcStationData] - Falha ao tentar inserir dados de volume pois não foi possível encontrar dados de volume"
          // );
          // console.log({ isVolumeDateInFuture, VOLUME_DATE: VOLUME_DATE });
          // throw "Não foi possível encontrar dados de volume";
        }
      } catch (e) {
        console.error(e);
        throw new Error(
          "Falha ao tentar calcular ET0, Volume e Precipitação - ",
          e
        );
      }
    },
    async getValveInfo(data) {
      const { ID, NAME, valves } = data.SECTOR;
      let FK_SECTOR = null;
      if (this.formType == "edit") {
        FK_SECTOR = ID;
      } else {
        const sector = await managementSectorUseCases().showByName.execute(
          NAME
        );
        FK_SECTOR = sector.ID;
      }
      const valve_name = valves[0].NAME;

      return {
        FK_VALVE: valves[0].ID,
        FK_SECTOR,
        NAME: valve_name,
      };
    },
    calcEt0PredictionFromEt0sDatas(et0, farmDap) {
      let et0_index = et0.findIndex((et0) => et0.TIME == farmDap.TIME);

      let isToday =
        moment(farmDap.TIME).format("YYYY-MM-DD") ==
        moment().format("YYYY-MM-DD");

      if (et0_index < 0 && !isToday) {
        return 0;
      } else if (et0_index < 0 && isToday) {
        et0_index = et0.length - 1;
      }

      //Primeiro index, então não consegue calcular a predição
      // pois precisa de algum valor antigo para fazer média
      if (et0_index === 0) {
        // console.log(
        //   ">>> Sem predição pois não há nenhum valor para calcular média"
        // );
        return 0;
      }

      const first_index = et0_index - 3; //Tenta pegar dados de 3 dias atrás
      let start = first_index >= 0 ? first_index : 0;
      let end = et0_index;

      if (isToday) {
        [start, end] = [et0.length - 3, et0.length];
      }

      let prevValues = et0.slice(start, end);
      const avg =
        prevValues.reduce((prev, current) => {
          if (typeof prev === "number") {
            return prev + current.VALUE;
          }
          return prev.VALUE + current.VALUE;
        }, 0) / prevValues.length;

      return Number(avg.toFixed(2));
    },
    async calcManagementData(management_sector, rainfall_inputs = null) {
      let {
        SECTOR: { ID, AREA, valves, PLANTING_DATE },
        MANAGEMENT: {
          ID_SECTOR,
          ID_FARM,
          ID_SOIL,
          DATE_CROP,
          SPACING_BETWEEN_LINES,
          SPACING_BETWEEN_PLANTS,
          SYSTEM_EFFICIENCY,
          APPLICATION_RATE,
          INITIAL_STORAGE,
          MAX_STORAGE,
          VOLUME_DATE,
        },
      } = management_sector;

      const calculatedManagementData = [];

      try {
        const now = moment().format("YYYY-MM-DD");

        //Se cadastrando setor com data no futuro então não deverá calcular volume, et0 e nem rainfall
        const hasVolumeGreaterThanNow = VOLUME_DATE
          ? moment(VOLUME_DATE).isAfter(now)
          : false;

        const sectorId = ID_SECTOR || ID;

        const valveFirstVolumeLog =
          await getFirstVolumeLogFromValveUseCase.execute(
            sectorId,
            valves[0].ID
          );

        const farmsDAP = await managementFarmDapUseCase().execute({
          ID_FARM,
          ID_SECTOR: sectorId,
          VOLUME: valveFirstVolumeLog,
          PLANTING_DATE,
          DATE_CROP,
          VOLUME_DATE,
        });
        if (farmsDAP && farmsDAP.length) {
          const soil = await soilUseCase().showSoilByIdUseCase.execute(ID_SOIL);

          const volumes = await getVolumeSinceFirstLogUseCase.execute(
            sectorId,
            valves[0].ID,
            valveFirstVolumeLog.TIME
          );

          const previousTimesToPrediction = moment(farmsDAP[0].TIME)
            .subtract(3, "days")
            .format("YYYY-MM-DD");

          let et0 = await getEt0SinceFirstLogUseCase.execute(
            previousTimesToPrediction
          );

          //Sugestão: ordenar pela a query
          et0 = et0.sort(function (a, b) {
            return a.TIME.localeCompare(b.TIME);
          });

          const rainfall = await getRainfallSinceFirstLogUseCase.execute(
            valveFirstVolumeLog.TIME
          );

          for (let [index, farmDAP] of farmsDAP.entries()) {
            const volumesData = volumes.find((vol) => vol.TIME == farmDAP.TIME);

            const rainfallData = rainfall[index] || 0.0;

            const currentEt0 = et0.find((et0) => et0.TIME == farmDAP.TIME);
            const et0Data = currentEt0 || 0.0;
            let soilStorage;

            if (soil) {
              soilStorage = this.calcSoilStorage(
                soil.WATER_DISPONIBILITY,
                farmDAP.DEPTH_ROOT
              );

              farmDAP.MAX_STORAGE = soilStorage;
            }

            farmDAP.PLANT_OCCUPANCY_SPACE = this.calcPlantOccupancyPortion(
              farmDAP.BRANCH,
              SPACING_BETWEEN_LINES,
              SPACING_BETWEEN_PLANTS
            );

            farmDAP.KL_FACTOR = this.calcKlFactor(
              farmDAP.PLANT_OCCUPANCY_SPACE
            );

            farmDAP.ET0 = et0Data ? fixFloatValue(et0Data.VALUE) : 0.0;

            farmDAP.ET0_PREDICTION = this.calcEt0PredictionFromEt0sDatas(
              et0,
              farmDAP
            );

            farmDAP.VOLUME = volumesData
              ? fixFloatValue(volumesData.VALUE)
              : 0.0;

            farmDAP.VOLUME_INPUT = volumesData
              ? fixFloatValue(
                  volumesData.VALUE_INPUT
                    ? volumesData.VALUE_INPUT
                    : farmDAP.VOLUME
                )
              : 0.0;

            farmDAP.RAINFALL = rainfallData
              ? fixFloatValue(Number(rainfallData.VALUE))
              : 0.0;

            const rainfallInput =
              rainfall_inputs &&
              rainfall_inputs.find(
                (rainfall) => rainfall.TIME === farmDAP.TIME
              );

            const hasRainfallInput = !!rainfallInput;
            const hasRainfallInputData =
              hasRainfallInput && rainfallInput.VALUE != null;

            // Não perder os dados de RAINFALL ao realizar cadastros no setor
            farmDAP.RAINFALL_INPUT =
              hasRainfallInput && hasRainfallInputData
                ? fixFloatValue(Number(rainfallInput.VALUE))
                : null;

            //Rever essa query pois atualmente busca dados de válvulas no LOG_ACTUATOR
            // pegando pelo dia anterior ao dia do FARM_DAP e tenta pegar o FLOW ou calcular na mão
            // a média  usando MIN_FLOW + MAX_LOW / 2, caso não tiver nada então retorna 0.
            // farmDAP.FLOW_AVG = await getEquipLogsTimeRangeUseCase().execute(
            //   valves[0].NAME,
            //   farmDAP.TIME
            // );

            farmDAP.FLOW_AVG = 0;

            const transmissivity = SYSTEM_EFFICIENCY * soil.TRANSMISSIVITY;
            farmDAP.IRRIGATED_BLADE = this.calcIrrigatedBlade(
              farmDAP.VOLUME_INPUT,
              AREA,
              transmissivity
            );

            farmDAP.ETC = this.calcEtc(
              farmDAP.ET0,
              farmDAP.KC,
              farmDAP.KL_FACTOR // TO-DO: usar KL_FACTOR como sendo 1
            );

            farmDAP.ETC_PREDICTION = this.calcEtc(
              farmDAP.ET0_PREDICTION,
              farmDAP.KC,
              farmDAP.KL_FACTOR // TO-DO: usar KL_FACTOR como sendo 1
            );

            if (index === 0) {
              farmDAP.INITIAL_STORAGE = Number(INITIAL_STORAGE);
            } else {
              farmDAP.INITIAL_STORAGE = this.calcInitialStorage(
                index,
                farmsDAP
              );
            }

            // if (index === 0) {
            //   farmDAP.INITIAL_STORAGE =
            //     INITIAL_STORAGE
            // } else {
            //   farmDAP.INITIAL_STORAGE = this.calcInitialStorage(index, farmsDAP);
            // }

            farmDAP.KS = this.calcKs(
              farmDAP.INITIAL_STORAGE,
              farmDAP.MAX_STORAGE,
              farmDAP.AVAILABILITY,
              index
            );

            // initialStorage, maxStorage, availability, Etc, Ks
            farmDAP.ETR = this.calcEtr(
              farmDAP.INITIAL_STORAGE,
              farmDAP.MAX_STORAGE,
              farmDAP.AVAILABILTY,
              farmDAP.ETC,
              farmDAP.KS,
              index
            );

            farmDAP.ETR_PREDICTION = this.calcEtr(
              farmDAP.INITIAL_STORAGE,
              farmDAP.MAX_STORAGE,
              farmDAP.AVAILABILTY,
              farmDAP.ETC_PREDICTION,
              farmDAP.KS
            );

            const [finalStorage, finalStorageExcess] = [
              ...this.calcFinalStorage(farmDAP),
            ];

            farmDAP.FINAL_STORAGE = finalStorage;
            farmDAP.EXCESS = finalStorageExcess;

            // if (index === 0 && Number(INITIAL_STORAGE) > MAX_STORAGE) {
            //   const diff = Number(INITIAL_STORAGE) - MAX_STORAGE
            //   farmDAP.EXCESS = diff + finalStorageExcess
            // } else {
            //   farmDAP.EXCESS = finalStorageExcess
            // }

            farmDAP.NEGATIVE_ACCUMULATED = this.calcNegativeAccumulated(
              farmDAP.ETR,
              farmDAP.IRRIGATED_BLADE
            );

            farmDAP.BLADE_SUGGESTION = this.calcBladeSuggestion(
              index,
              farmsDAP
            );

            farmDAP.IRRIGATION_TIME_FLOW = 0;

            farmDAP.IRRIGATION_TIME_APP_RATE = 0;
          }

          farmsDAP.map((farm_dap) => {
            calculatedManagementData.push({
              ID_FARM,
              ID_DAP: farm_dap.DAP,
              ID_SECTOR: ID_SECTOR || ID,
              TIME: hasVolumeGreaterThanNow ? VOLUME_DATE : farm_dap.TIME,
              PLANT_OCCUPANCY_SPACE: farm_dap.PLANT_OCCUPANCY_SPACE,
              KL_FACTOR: farm_dap.KL_FACTOR,
              VOLUME: farm_dap.VOLUME,
              VOLUME_INPUT: farm_dap.VOLUME_INPUT,
              RAINFALL: farm_dap.RAINFALL,
              RAINFALL_INPUT: farm_dap.RAINFALL_INPUT,
              FLOW_AVG: farm_dap.FLOW_AVG,
              MAX_STORAGE: farm_dap.MAX_STORAGE,
              IRRIGATED_BLADE: farm_dap.IRRIGATED_BLADE,
              ETC: farm_dap.ETC,
              INITIAL_STORAGE: farm_dap.INITIAL_STORAGE,
              KS: farm_dap.KS,
              ETR: farm_dap.ETR,
              ETR_PREDICTION: farm_dap.ETR_PREDICTION,
              ET0: farm_dap.ET0,
              ET0_PREDICTION: farm_dap.ET0_PREDICTION,
              FINAL_STORAGE: farm_dap.FINAL_STORAGE,
              EXCESS: farm_dap.EXCESS,
              NEGATIVE_ACCUMULATED: farm_dap.NEGATIVE_ACCUMULATED,
              BLADE_SUGGESTION: farm_dap.BLADE_SUGGESTION,
              IRRIGATION_TIME_FLOW: farm_dap.IRRIGATION_TIME_FLOW,
              IRRIGATION_TIME_APP_RATE: farm_dap.IRRIGATION_TIME_APP_RATE,
              WATER_DISPONIBILITY: soil.WATER_DISPONIBILITY,
            });
          });
        }
      } catch (e) {
        console.error(">>> Falha ao tentar calcular Manejo. \n", e);
      }

      return calculatedManagementData;
    },
    convertTimestampToDate(array) {
      return array.map((item) => {
        const [timestamp, value] = item;
        return [moment(timestamp).format("YYYY-MM-DD"), value];
      });
    },
    async getStationLogs(MEDITIONS, STATION, START, END_DATE = null) {
      const NAMES = STATION.NAME;
      const UNITS = MEDITIONS.UNITS;
      const TYPES = MEDITIONS.TYPES;

      const END = END_DATE
        ? END_DATE
        : moment().subtract(1, "day").format("YYYY-MM-DD HH:mm");

      const STATION_INFO = {
        ALTITUDE: STATION.ALTITUDE,
        ANEMOMETER_HEIGHT: STATION.H_ANEMOMETRO,
        LONGITUDE: STATION.LONGITUDE,
        LATITUDE: STATION.LATITUDE,
        NAME_STATION: `Estação ${STATION.ADDR}`,
        FK_STATION: STATION.ADDR,
        UTC: -3,
      };

      const payload = {
        EQP: "SENSOR",
        //Será mesmo necessário filtrar os Nomes da estação?
        NAME: NAMES.filter((e, i, arr) => arr.indexOf(e) == i),
        COLUMN: "UNIT",
        CONDITION: {
          TYPES: TYPES.filter((e, i, arr) => arr.indexOf(e) == i),
          UNITS: UNITS.filter((e, i, arr) => arr.indexOf(e) == i),
        },
        START,
        END,
      };

      try {
        const sensorLogs = await monitChart.create(
          payload,
          new AbortController()
        );
        let stationLogs = null;

        //Conseguir buscar logs do sensor EMR (Sensor da estação)
        if (sensorLogs.status) {
          stationLogs = await organizeLog(sensorLogs, "STATION", NAMES);
        } else {
          alert(sensorLogs.log, "w");
          throw sensorLogs.log;
        }
        //Não conseguir montar os logs da estação
        if (!stationLogs.status) {
          alert(stationLogs.log, "w");
          throw stationLogs.log;
        }

        return {
          INFO: {
            STATION: STATION_INFO,
            INTERVAL: {
              START,
              END,
            },
          },
          LOGS: stationLogs.value,
        };
      } catch (error) {
        throw new Error("[getStationLogs] - ", error);
      }
    },
    sumElems(arr) {
      return arr.reduce((acc, value) => acc + value, 0);
    },
    organizeStationLogs(data, START) {
      let only_time = data
        .map((item) => moment(item[0]).format("YYYY-MM-DD"))
        .filter((el) => !!el);

      //const START = "2022-05-17"; //Primeiro registro de volume
      // Data de ontem (último registro)
      const END = moment().subtract(1, "day").format("YYYY-MM-DD");

      let index = 0;

      let current_date = moment(START).subtract(1, "day").format("YYYY-MM-DD");

      while (current_date < END) {
        current_date = moment(current_date).add(1, "day").format("YYYY-MM-DD");
        index += 1;
        // Se a data já estiver no registro de DATAS
        // então ignora
        if (only_time.some((time) => time === current_date)) {
          continue;
        }

        data.splice(index, 0, [current_date, "0.00"]);
      }

      return data;
    },
    async calcStationData(LOGS, INFO) {
      const {
        INTERVAL: { START, END },
        STATION,
      } = INFO;

      // console.log(
      //   "oque esta sendo passado pro calcEt0",
      //   LOGS,
      //   INFO,
      //   STATION,
      //   LOGS,
      //   START,
      //   END
      // );

      let infoWithET0 = await this.calcET0(STATION, LOGS, START, END);

      let end = moment(END).format("YYYY-MM-DD");

      const organizedEt0Data = this.organizeStationLogs(
        infoWithET0.ET0.data,
        START
      );

      const et0 = {
        FK_STATION: STATION.FK_STATION,
        START,
        END: end,
        DATA: this.convertTimestampToDate(organizedEt0Data),
      };

      const hasRainfall = Reflect.has(
        infoWithET0,
        "ALTURA PLUVIOMÉTRICA DIÁRIA"
      );

      if (!hasRainfall) {
        //Caso não tiver precipitação então preenche com 0.00
        // de acordo com os dias pegues da ET0
        infoWithET0["ALTURA PLUVIOMÉTRICA DIÁRIA"] = {
          data: infoWithET0.ET0.data.map((et0) => {
            let [TIME] = et0;
            return [TIME, "0.00"];
          }),
        };
      }

      let organizedRainfallData = this.organizeStationLogs(
        infoWithET0["ALTURA PLUVIOMÉTRICA DIÁRIA"].data,
        START
      );

      let rainfall = {
        FK_STATION: STATION.FK_STATION,
        START,
        END: end,
        DATA: this.convertTimestampToDate(organizedRainfallData),
      };

      return { et0, rainfall };
    },
    async getStationInfo() {
      const monitStationData = await monit.station();
      //Conseguiu pegar dados do DIR + Estação
      if (monitStationData.status) {
        const station = monitStationData.value[0];
        const sensorId = station.EMR;

        const { STATION_NAME, UNITS, TYPES } =
          await getStationOptionsUseCase.execute(sensorId);

        station["NAME"] = STATION_NAME;

        return {
          station,
          meditions: {
            TYPES,
            UNITS,
          },
        };
      } else {
        alert(monitStationData.log, monitStationData.alert);

        return {
          station: null,
          meditions: null,
        };
      }
    },
    async calcEt0AndRainfall(START, END = null) {
      const { station, meditions } = await this.getStationInfo();
      //Conseguir pegar medições da estação para calcular ET0
      if (meditions) {
        const { INFO, LOGS } = await this.getStationLogs(
          meditions,
          station,
          START,
          END
        );

        const { et0, rainfall } = await this.calcStationData(LOGS, INFO);
        return { et0, rainfall };
      } else {
        console.error("Não foi possível buscar dados da estação.");
        throw new Error("Não foi possível buscar medições da estação.");
      }
    },
    //semelhante do monitoramento de estação e CRON
    async calcET0(info, station, START, END) {
      // console.log("o que eu passo pro calcEt0", info, station, START, END);
      return new Promise((resolve) => {
        let hours = [
          "00",
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
        ];
        let end = END.split(" ")[0];
        let date = START.split(" ")[0];
        let et0s = [];
        let z1 = info.ANEMOMETER_HEIGHT;
        let long = Number(info.LONGITUDE);
        const PI = Math.PI;
        const localLat = info.LATITUDE * (PI / 180); //convertido para radianos

        let now = moment().format("YYYY-MM-DD");

        station.typesPerSns.splice(0, 0, "ET0");
        station.ET0 = {
          measure: "ET0 diária",
          unit: "mm",
          data: [],
        };

        for (
          date;
          date <= end;
          date = moment(date).add(1, "day").format("YYYY-MM-DD")
        ) {
          for (let h = 0; h < hours.length; h++) {
            try {
              let key = `${date} ${hours[h]}`;
              let windVelocity = station["VELOCIDADE DO VENTO"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let atmospherePreasure = station[
                "PRESSÃO ATMOSFÉRICA"
              ].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let solarRadiation = station["RADIAÇÃO SOLAR"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let airTemperature = station["TEMPERATURA DO AR"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );

              const airHumidityRegex = new RegExp("^UMIDADE RELATIVA..*AR$");
              let airHumidityData = null;
              // Umidade relativa do ar pode apresentar caracteres espaçados entre as letras
              Object.entries(station).forEach(([key, value]) => {
                if (airHumidityRegex.test(key)) airHumidityData = value.data;
              });
              let airHumidity = airHumidityData.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let avgTemp = 0;
              let avgHumid = 0;
              let avgVel = 0;
              let rs = 0;
              let avgPreas = 0;
              if (airTemperature.length) {
                let temps = airTemperature.map((e) => Number(e[1]));
                let maxTemp = Math.max(...temps);
                let minTemp = Math.min(...temps);
                avgTemp = (maxTemp + minTemp) / 2;
              }
              if (airHumidity.length) {
                let humids = airHumidity.map((e) => Number(e[1]));
                let maxHumid = Math.max(...humids);
                let minHumid = Math.min(...humids);
                avgHumid = (maxHumid + minHumid) / 2;
              }
              if (windVelocity.length) {
                let vels = windVelocity.map((e) => Number(e[1]));
                avgVel = this.sumElems(vels) / vels.length;
                if (z1 !== null && z1 != 2)
                  avgVel = (avgVel * 4.87) / Math.log(67.8 * z1 - 5.42);
              }
              if (solarRadiation.length) {
                let rads = solarRadiation.map((e) => Number(e[1]));
                const seconds_between_reads = 3600 / solarRadiation.length;
                rs =
                  rads.reduce((acc, e) => e * seconds_between_reads + acc, 0) /
                  Math.pow(10, 6); //converte para MJ/m²h;
              }
              if (atmospherePreasure.length) {
                let preas = atmospherePreasure.map((e) => Number(e[1]));
                avgPreas = this.sumElems(preas) / preas.length / 10; //converte de hPa para kPa
              }

              const Gsc = 0.082; //MJ/m²/min
              const dayOfYear = moment(date).dayOfYear();
              const delta = 0.409 * Math.sin((2 * PI * dayOfYear) / 365 - 1.39);
              const Dr = 1 + 0.033 * Math.cos((2 * PI * dayOfYear) / 365);
              const auxSc = (2 * PI * (dayOfYear - 81)) / 364;
              const Sc =
                0.1645 * Math.sin(2 * auxSc) -
                0.1255 * Math.cos(auxSc) -
                0.025 * Math.sin(auxSc);

              const omegaAuxT = parseInt(h) + 0.5;
              let omegaAuxLm = long < 0 ? long * -1 : 360 - long;
              const omegaAuxLz = ((utc) => {
                let Lz = 0;
                let deg = utc * -1 * 15;
                Lz = utc < 0 ? deg : 360 - deg;
                return Lz;
              })(Number(info.UTC));
              const omega =
                ((omegaAuxLz - omegaAuxLm) * 0.06667 + omegaAuxT + Sc - 12) *
                (PI / 12);
              let Ra;
              let Rso;
              let Rns;

              let kt = 0.95; // índice de turbidez do ar
              let denAuxFirstPart = Math.sin(localLat) * Math.sin(delta);
              let denAuxSecondPart =
                Math.cos(localLat) * Math.cos(delta) * Math.cos(omega);
              let den = denAuxFirstPart + denAuxSecondPart;
              let omegaS = Math.acos(-Math.tan(localLat) * Math.tan(delta));
              if (omega < -omegaS || omega > omegaS) {
                Ra = 0;
              } else {
                const omega1 = omega - PI / 24;
                const omega2 = omega + PI / 24;
                const RaAuxOmegasDiff = omega2 - omega1;
                const RaAuxFirstPart =
                  RaAuxOmegasDiff * Math.sin(localLat) * Math.sin(delta);
                const RaAuxSinDiff = Math.sin(omega2) - Math.sin(omega1);
                const RaAuxSecondPart =
                  RaAuxSinDiff * Math.cos(localLat) * Math.cos(delta);
                const RaAuxA = RaAuxFirstPart + RaAuxSecondPart;
                Ra = (12 * 60 * Gsc * Dr * RaAuxA) / PI;
              }
              Rso = Ra * Math.exp((-0.0018 * avgPreas) / (kt * den));
              Rns = (1 - 0.23) * rs;
              const eThrAux = (17.27 * avgTemp) / (avgTemp + 237.3);
              const eThr = 0.6108 * Math.exp(eThrAux);
              const Ea = (eThr * avgHumid) / 100;
              const DELTA =
                (4098 * eThr) / ((avgTemp + 237.3) * (avgTemp + 237.3));
              const gama = 0.665 * 0.001 * avgPreas;
              const sigma = 2.043 * Math.pow(10, -10); //em MJ/m²h
              const RnlAuxFirstPart = sigma * Math.pow(avgTemp + 273.16, 4);
              const RnlAuxSecondPart = 0.34 - 0.14 * Math.pow(Ea, 0.5);
              const RnlDivisionAuxThirdPart = Rso == 0 ? 0.8 : rs / Rso; //valor assumido quando Rso = 0 de acordo com exemplo
              const RnlAuxThirdPart = 1.35 * RnlDivisionAuxThirdPart - 0.35;
              const Rnl = RnlAuxFirstPart * RnlAuxSecondPart * RnlAuxThirdPart;
              const Rn = Rns - Rnl;
              const G = omega < -omegaS || omega > omegaS ? 0.5 * Rn : 0.1 * Rn;
              // const G = h > 5 && h < 18 ? 0.5 * Rn : 0.1 * Rn;

              /* Finalmente, o cálculo da ET0 */
              const ET0AuxFirstPartNumerator = 0.408 * (Rn - G);
              const ET0AuxFirstPart =
                (ET0AuxFirstPartNumerator * DELTA) /
                (DELTA + gama * (1 + 0.34 * avgVel));
              const ET0AuxSecondPartNumerator = 37 / (avgTemp + 273);
              const ET0AuxSecondPart =
                (ET0AuxSecondPartNumerator * avgVel * (eThr - Ea) * gama) /
                (gama * (1 + 0.34 * avgVel) + DELTA);
              const ET0 = ET0AuxFirstPart + ET0AuxSecondPart;

              et0s[h] = String(ET0) == "NaN" || ET0 < 0 ? 0.0 : ET0;
            } catch (e) {
              console.log(">>> calcET0 - ", e);
            }
          }
          if (date !== end) {
            //Data futura
            if (moment(date).diff(now) > 0) {
              let yesterday = moment(now)
                .subtract(1, "day")
                .format("YYYY-MM-DD");
              station.FK_STATION = info.FK_STATION;
              station.ET0.data.push([
                Math.round(new Date(yesterday + "T00:00:00").getTime()),
                this.sumElems(et0s).toFixed(2),
              ]);
            } else {
              station.FK_STATION = info.FK_STATION;
              station.ET0.data.push([
                Math.round(new Date(date + "T00:00:00").getTime()),
                this.sumElems(et0s).toFixed(2),
              ]);
            }
          }
        }
        resolve(station);
      });
    },
    async saveOffSetDap(data) {
      let TIME = moment().format("YYYY-MM-DD");

      let {
        MANAGEMENT: { OFFSET_DAP, ID_SECTOR },
        SECTOR: { ID },
      } = data;

      const sectorId = ID_SECTOR || ID;

      if (this.formType == "edit") {
        let previousLogSector = await showLogSectorByIdAndTimeUseCase().execute(
          sectorId,
          TIME
        );

        //Caso não tiver algo no banco então terá que salvar
        // Não será comum, mas é só uma garantia na realização dos testes
        if (!previousLogSector) {
          await createLogSectorUseCase().execute({
            ID_SECTOR: sectorId,
            TIME,
            OFFSET: OFFSET_DAP,
          });
        }

        if (previousLogSector && previousLogSector.OFFSET !== OFFSET_DAP) {
          await updateOffsetSectorByIdSector().execute(sectorId, OFFSET_DAP);
        }
      } else {
        await createLogSectorUseCase().execute({
          ID_SECTOR: sectorId,
          TIME,
          OFFSET: OFFSET_DAP,
        });
      }
    },
    async deleteManagementDatasFromSector(ID) {
      await deleteLogSectorByIdUseCase().execute(ID);
      await deleteManagementByIdSector().execute(ID);
      await managementSectorUseCases().deleteById.execute(ID);
      await deleteVolumeBySector().execute(ID);
    },
    async registerManagementSectorAux(
      SECTOR_PROPS,
      HAS_CHANGED_VALVES = false
    ) {
      const { FK_VALVE, FK_SECTOR, NAME } = this.currentValves;

      /*
        Caso for cadastrar ou editar um setor de manejo colocando a data de colheita em dias
        anteriores a data em que está sendo realizado o cadastro, irá ter que considerar a data
        de colheita.
      */
      if (!this.recalcUntilCrop) {
        const today = moment().format("YYYY-MM-DD");
        const dateCropIsBeforeToday = moment(
          SECTOR_PROPS.MANAGEMENT.DATE_CROP
        ).isBefore(today);
        this.recalcUntilDateCrop = dateCropIsBeforeToday;
      }

      let end = "";
      let start = "";

      end = this.recalcUntilDateCrop
        ? moment(SECTOR_PROPS.MANAGEMENT.DATE_CROP)
            .hours(23)
            .minutes(59)
            .format("YYYY-MM-DD")
        : moment().hours(23).minutes(59).format("YYYY-MM-DD");

      const elements = {
        ID: FK_VALVE,
        NAME,
      };

      start = SECTOR_PROPS.MANAGEMENT.VOLUME_DATE
        ? moment(SECTOR_PROPS.MANAGEMENT.VOLUME_DATE)
            .hours(0)
            .minutes(0)
            .format("YYYY-MM-DD")
        : moment()
            .subtract(1, "months")
            .hours(0)
            .minutes(0)
            .format("YYYY-MM-DD");

      const PAYLOAD = {
        start,
        end,
        elements,
        equipment: "actuator",
        type: "volume",
        organization: "raw",
        interval: 24,
      };

      const now = moment().format("YYYY-MM-DD");

      //Se cadastrando setor com data no futuro então não deverá calcular volume, et0 e nem rainfall
      if (moment(start).isAfter(now)) {
        console.warn("Não irá ser calculado et0, rainfall e nem volume.");
        return;
      }

      //Sugestão: Verificar o caso de der algum erro na geração do Volume, ET0 e Rainfall
      // caso aconteça algum erro nesses cálculos então é ideal que não salve OFFSET no
      // LOG_SECTOR.
      await this.saveOffSetDap(SECTOR_PROPS);

      //Verificar se tem estação
      const monitStationData = await monit.station();
      const hasStation = !!monitStationData.status;

      // Irá calcular os volumes do setor e salvar os dias que não foram inseridos na tabela CROP.VOLUME
      if (this.shouldHaveHistory(SECTOR_PROPS.MANAGEMENT.VOLUME_DATE)) {
        // console.log(
        //   "Não calculará volume e dados de estação, pois a data inicial de manejo é no futuro"
        // );
        return;
      }

      await this.calcVolumes(FK_SECTOR);

      if (hasStation) {
        const result = await this.calcPrepareStationData({
          FK_VALVE,
          FK_SECTOR,
          NAME,
          VOLUME_DATE: SECTOR_PROPS.MANAGEMENT.VOLUME_DATE,
          PAYLOAD,
          HAS_CHANGED_VALVES,
        });

        return this.saveStationDatas(result);
      }
    },
    async registerManagement(SECTOR_ID, MANAGEMENT_DATA) {
      const firstRegisterOfManagement = MANAGEMENT_DATA[0].TIME;

      const lastRegisterOfManagement =
        MANAGEMENT_DATA[MANAGEMENT_DATA.length - 1].TIME;

      const hasManagement =
        await getManagementByIdSectorAndIntervalUseCase().execute(
          SECTOR_ID,
          firstRegisterOfManagement,
          lastRegisterOfManagement
        );

      if (!hasManagement) {
        await saveManagementUseCase().execute(MANAGEMENT_DATA);
      } else {
        //Deleta na força bruta por intervalo de cálculo
        await deleteManagementBySectorAndInterval().execute(
          SECTOR_ID,
          firstRegisterOfManagement,
          lastRegisterOfManagement
        );

        await saveManagementUseCase().execute(MANAGEMENT_DATA);
      }
    },
    async updateSectorHandler(SECTOR_PROPS) {
      //Caso for editar um setor que antes não era de manejo, irá adicionar o ID no management
      if (!SECTOR_PROPS.MANAGEMENT.ID_SECTOR) {
        SECTOR_PROPS.MANAGEMENT.ID_SECTOR = SECTOR_PROPS.SECTOR.ID;
      }

      const sectorAlreadyExists =
        await managementSectorUseCases().checkManagementSector.execute(
          SECTOR_PROPS.MANAGEMENT.ID_SECTOR
        );

      if (!sectorAlreadyExists) {
        // console.log(">>> Criando setor de manejo");
        await managementSectorUseCases()["add"].execute(
          SECTOR_PROPS.MANAGEMENT
        );
      }

      // Caso apenas estiver editando o setor que antes já era de manejo
      else {
        //Apagar dados posteriores da data de colheita para evitar lixo no banco
        if (SECTOR_PROPS.HAS_CHANGED_DATE_CROP) {
          //Buscar último dia de manejo e comparar a data de colheita
          // Se a data de colheita for menor do que a data de manejo, então apaga os dados após a data de manejo

          const managementData =
            await getLastRecordFromManagementByIdSector().execute(
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR
            );

          const managementTime = managementData ? managementData.TIME : null;
          const isBeforeManagementDate = managementTime
            ? moment(SECTOR_PROPS.MANAGEMENT.DATE_CROP).isBefore(managementTime)
            : false;

          if (isBeforeManagementDate) {
            await deleteManagementBySectorAndInterval().execute(
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
              SECTOR_PROPS.MANAGEMENT.DATE_CROP
            );

            await deleteVolumeByInterval().execute(
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
              SECTOR_PROPS.MANAGEMENT.DATE_CROP
            );

            //Indicador para saber quando usar a data de COLHEITA no cálculo de volume
            this.recalcUntilDateCrop = true;
          }
        }

        await managementSectorUseCases()[this.formType].execute(
          SECTOR_PROPS.MANAGEMENT
        );
      }

      const oldValve = SECTOR_PROPS.SECTOR.oldValves;
      //Se não foi trocado de válvula então será null, caso tenha trocado de válvula ou terá a string com a data
      //ou será "" (Caso tenha apagado a data)
      const oldManagementInitialDate =
        SECTOR_PROPS.SECTOR.oldManagementInitialDate;

      const hasChangedManagementInitialDate = oldManagementInitialDate !== null;

      const hasChangedValves = !!oldValve && oldValve.length;

      const hasAddedNewValve =
        hasChangedValves &&
        oldValve[0].NAME !== SECTOR_PROPS.SECTOR.valves[0].NAME;

      const SECTOR_ID =
        SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;
      //Quando trocar de válvula ou trocar de data de manejo, irá recalcular tudo
      if (hasAddedNewValve || hasChangedManagementInitialDate) {
        if (hasAddedNewValve) {
          // console.log(
          //   ">>> Calculando tudo de novo pois foi trocado de válvula "
          // );
        }
        if (hasChangedManagementInitialDate) {
          // console.log(
          //   ">>> Calculando tudo de novo pois foi trocado a data inicial de manejo para ",
          //   SECTOR_PROPS.MANAGEMENT.VOLUME_DATE || "Vazio"
          // );
        }
        //Ao trocar de válvula também irá ter que apagar dados no MANAGEMENT
        await deleteManagementByIdSector().execute(SECTOR_ID);
        await this.registerManagementSectorAux(SECTOR_PROPS, hasAddedNewValve);
      }
      //Editar um setor que antes não tinha válvula ou Editar um setor sem mudar a válvula
      else {
        const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
        const valveId = SECTOR_PROPS.SECTOR.valves[0].ID;
        const hasRegisterFromVolume =
          await getVolumeByIdSectorAndTimeUseCase.execute(
            SECTOR_ID,
            valveId,
            yesterday
          );

        // Se tiver registro é por que  estou editando sem trocar de válvula
        // console.log(
        //   `>>> Verificando se há registros de setor na data ${yesterday} (Ontem) >>> `,
        //   { hasRegisterFromVolume }
        // );
        //Estou editando um setor que antes não era de manejo e agora irá ser de manejo
        if (!hasRegisterFromVolume) {
          await this.registerManagementSectorAux(SECTOR_PROPS);
        }
      }
    },
  },
};
